import { Accordion, Spinner, useAccordionButton } from "react-bootstrap";
import { useGetReceivedOffers } from "../../../api/query_hooks/offer";
import ReceivedOfferDetails from "./ReceivedOfferDetails";

const ReceivedOffersPanel = ({id="", requestId, offers=[]}) => {

    const offersQuery = useGetReceivedOffers(requestId);


    return (
        <>
            {offersQuery.isLoading &&
                <div className='bg-dark flex-center gap-2 col-7 h-100 rounded-bottom m-auto'>
                    <Spinner animation="border" role="status" aria-describedby="loading" />
                </div>
            }
            {offersQuery.isError &&
                <div className='bg-dark flex-center gap-2 col-7 h-100 rounded-bottom m-auto'>
                    {offersQuery.error.response?.data}
                </div>
            }
            { offersQuery.isSuccess &&
                <div className="bg-darker d-flex flex-column flex-grow-1 mx-3 mb-2 rounded border border-2 border-black">
                    <div className="d-flex col-12 border-bottom border-2 border-black">
                        <p className="text-mini user-select-none flex-center col-12 m-0">Offers</p>
                    </div>
                    {offersQuery.data?.data.length ?
                        <Accordion>
                            {offers.map((offer, index) => (
                                <ReceivedOfferDetails key={index} eventKey={index} offer={offer} />
                            ))}
                        </Accordion>
                    :
                        <div className="d-flex flex-center flex-column h-100">
                            <box-icon color='white' size='md' type='solid' name='x-circle'></box-icon>
                            <p className="m-1 text-mini">No offers have been made yet</p>
                        </div>
                    }
                </div>
            }
        </>
    );
};


export default ReceivedOffersPanel;